import { useEffect, useState } from "react"

/**
 * Determines if an image fits within a container based on its aspect ratio and
 * a tolerance threshold.
 */
export function useImageFit(
  thumbnailUrl: string,
  targetAspectRatio: number,
  threshold: number,
) {
  const [fitsContainer, setFitsContainer] = useState(false)

  useEffect(() => {
    const img = new Image()

    // We must wait for the image to load before checking its aspect ratio.
    img.onload = () => {
      if (img.height === 0) {
        setFitsContainer(false)
        return
      }

      const imageAspectRatio = img.width / img.height
      const aspectRatioDifference = Math.abs(
        imageAspectRatio - targetAspectRatio,
      )
      setFitsContainer(aspectRatioDifference <= threshold)
    }

    img.src = thumbnailUrl
  }, [thumbnailUrl, targetAspectRatio, threshold])

  return fitsContainer
}
